import React from 'react';

// Product lockup in the sidebar's top zone. Partners know the tills as
// "dxPos" because that's what the POS screen says; this gives dxWeb the same
// visible name. The mark is the DX logo path used by dxPos (login_logo.svg),
// inlined so it inherits `currentColor`.
const SidebarBrand = () => (
    <div className="sidebar-brand" role="img" aria-label="dxWeb" data-e2e="sidebar-brand">
        <svg className="sidebar-brand__mark" viewBox="0 0 568.5 189.1" aria-hidden="true" focusable="false">
            <path
                fill="currentColor"
                d="M568.5,0.1H446l-94.1,57.1l-25.4-25.4C294.9,0.2,246.8,0.2,246.4,0.1H79.3l-79,188.3L0,189.1l175.9-1.9c90.9,0,159.7-46.9,165.2-50.7l46.1,46.1h95.1l-81.7-81.7L568.5,0.1z M297,90.3c-5.4,4.8-65.8,57.7-116,57.7c-48.5,0-84.1,0.5-89.7,0.6l47.2-114h68.4c0.3,0,31-3.4,54.6,20.3C283.1,76.4,294.8,88.1,297,90.3z"
            />
        </svg>
        <span className="sidebar-brand__product" aria-hidden="true">
            Web
        </span>
    </div>
);

export default SidebarBrand;
